module.exports = {
  Ordering: {
    PluginName: "Ordenar",
    content_box_name: "Content",
    Statement:
      "Es una pregunta de clasificación que implica el orden correcto de las respuestas. Puede escribir una oración de pregunta aquí.",
    Question: "Pregunta",
    Answer: "Respuesta",
    Feedback: "Realimentación",
    FeedbackMsg:
      "Puede escribir un comentario sobre la respuesta. Puede desactivar esta función desde la barra de herramientas.",
    TrueFeedbackMsg:
      "Aquí puedes añadir una explicación sobre la respuesta correcta. Puedes desactivar esta opción en la barra de herramientas.",
    FalseFeedbackMsg:
      "Aquí puedes añadir una explicación sobre la respuesta incorrecta. Puedes desactivar esta opción en la barra de herramientas.",
    ShowFeedback: "Mostrar mensaje de realimentación",
    ShowStars: "Mostrar estrellas en vez de números",
    background_color: "Color de Fondo",
    border_color: "Color de Borde",
    border_size: "Grosor de Borde",
    border_style: "Estilo de Borde",
    box_style: "Estilo Caja",
    opacity: "Opacidad",
    padding: "Padding",
    pos: "Posición",
    radius: "Radio",
    source: "Fuente",
    Number: "Nº de Niveles",
    Color: "Color",
    tryAgain: "Inténtalo de nuevo",
    checkAnswer: "Comprueba la respuesta",
    notCount: "Este ejercicio no añade puntos a la nota",

    Matching: {
      PluginName: "Emparejamiento",
      content_box_name: "Content ",
      Statement:
        "Esta es una pregunta de opción múltiple con una única respuesta correcta. Puede escribir aquí el enunciado de la pregunta. ",
      Question: "Pregunta",
      Feedback: "Realimentación",
      FeedbackMsg:
        "Puede escribir un comentario sobre la respuesta. Puede desactivar esta función desde la barra de herramientas.",
      TrueFeedbackMsg:
        "Aquí puedes añadir una explicación sobre la respuesta correcta. Puedes desactivar esta opción en la barra de herramientas.",
      FalseFeedbackMsg:
        "Aquí puedes añadir una explicación sobre la respuesta incorrecta. Puedes desactivar esta opción en la barra de herramientas.",
      ShowFeedback: "Mostrar mensaje de realimentación",
      Number: "Numero de Respuestas",
      ShowLettersInsteadOfNumbers: "Letras en lugar de números",
      background_color: "Color de Fondo",
      border_color: "Color de Borde",
      border_size: "Grosor de Borde",
      border_style: "Estilo de Borde",
      box_style: "Estilo Caja",
      opacity: "Opacidad",
      padding: "Padding",
      pos: "Posición",
      radius: "Radio",
      source: "Fuente",
      Answer: "Respuesta",
      Number: "Número",
      Color: "Color",
      Correct: "Correcto",
      tryAgain: "Inténtalo de nuevo",
      checkAnswer: "Comprueba la respuesta",
    },
  },
};
